module.exports = __webpack_public_path__ + "img/Surface-Tooltip.0f4d191c.svg";